import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomFrom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function generateTask() {
  const solid = randomFrom([
    "graniastosłup prawidłowy trójkątny",
    "ostrosłup prawidłowy czworokątny",
    "stożek",
  ]);
  const k = randInt(2, 4);
  const p1 = randInt(10, 50);
  const p2 = p1 * k * k;
  const v1 = randInt(12, 80);
  const v2 = v1 * k * k * k;

  return {
    type: "SimilarSolidVolumeFromAreaScaleTask",
    data: { solid, k, p1, p2, v1, v2 },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>
        Dwie bryły podobne mają kształt: <strong>{data.solid}</strong>.
      </p>
      <p>
        Pole powierzchni pierwszej bryły to{" "}
        <InlineMath math={`${data.p1}\\,\\text{cm}^2`} />, a drugiej{" "}
        <InlineMath math={`${data.p2}\\,\\text{cm}^2`} />.
      </p>
      <p>
        Objętość pierwszej bryły wynosi{" "}
        <InlineMath math={`${data.v1}\\,\\text{cm}^3`} />.
      </p>
      <p>Oblicz objętość drugiej bryły.</p>
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="V_2"
      suffixLatex={String.raw`\text{cm}^3`}
      placeholder="np. 432"
    />
  );
}

export function checkAnswer(task, userAnswer) {
  const parsed =
    userAnswer && typeof userAnswer === "object" ? userAnswer.parsed : NaN;
  if (!Number.isFinite(parsed)) return { correct: false };
  return { correct: Math.abs(parsed - task.data.v2) < 0.01 };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`V_2=${data.v2}\\,\\text{cm}^3`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return (
    <InlineMath
      math={`${formatLatexPreview(userAnswer.raw, "V_2")}\\,\\text{cm}^3`}
    />
  );
}

export function renderExplanation({ data }) {
  const ratioP = data.p2 / data.p1;
  const k3 = data.k ** 3;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong> Dla brył podobnych:
      </p>
      <BlockMath math={`\\frac{P_2}{P_1}=k^2`} />
      <BlockMath math={`k=\\sqrt{\\frac{P_2}{P_1}}=\\sqrt{\\frac{${data.p2}}{${data.p1}}}=\\sqrt{${ratioP}}=${data.k}`} />
      <p>
        <strong>Krok 2:</strong> Skala objętości to <InlineMath math={"k^3"} />:
      </p>
      <BlockMath math={`V_2=V_1\\cdot k^3=${data.v1}\\cdot ${k3}=${data.v2}\\,\\text{cm}^3`} />
    </div>
  );
}

